import img1 from "./assets/imgs/slideimg.png"
import img6 from "./assets/imgs/sliderimg2.png"
import img2 from "./assets/imgs/img2.png"
import img3 from "./assets/imgs/img3.png"
import img4 from "./assets/imgs/img4.png"
import img5 from "./assets/imgs/img5.png"
import img7 from "./assets/imgs/img7.png"
import img9 from "./assets/imgs/img9.png"
import img10 from "./assets/imgs/img7.png"
import img11 from "./assets/imgs/img11.png"
import img13 from "./assets/imgs/img13.png"
import img14 from "./assets/imgs/img14.png"
import img15 from "./assets/imgs/img15.png"


const data = [
  {
    id: 1,
    name: "Barberton Daisy",
    price: 119.00,
    img: img1,
    type: "New Arrivals",
    categories: "House Plants"
  },
  {
    id: 2,
    name: "Angel Wing Begonia",
    price: 169.00,
    img: img2,
    type: "New Arrivals",
    categories: "House Plants"
  },
  {
    id: 3,
    name: "African Violet",
    price: 199.00,
    img: img3,
    type: "New Arrivals",
    categories: "House Plants"
  },
  {
    id: 4,  
    name: "Beach Spider Lily",
    price: 129.00,
    img: img4,
    type: "New Arrivals",
    categories: "House Plants"
  },
  {
    id: 5,
    name: "Blushing Bromeliad",
    price: 139.00,
    img: img5,
    type: "New Arrivals",
    categories: "House Plants"
  },
  {
    id: 6,  
    name: "Aluminum Plant",
    price: 179.00,
    img: img4,
    type: "New Arrivals",
    categories: "House Plants"
  },
  {
    id: 7,
    name: "Bird's Nest Fern",
    price: 99.00,
    img: img6,
    type: "New Arrivals",
    categories: "House Plants"
  },
  {
    id: 8,  
    name: "Broadleaf Lady Palm",
    price: 59.00,
    img: img7,
    type: "New Arrivals",
    categories: "House Plants"
  },
  {
    id: 9,  
    name: "Chinese Evergreen",
    price: 39.00,
    img: img9,
    type: "New Arrivals",
    categories: "House Plants"
  },
  {
    id: 10,  
    name: "Super Sale",
    price: 179.00,
    img: img4,
    type: "Sale",
    categories: "Potter Plants"
  },
  {
    id: 11,
    name: "Bird's Nest Fern",
    price: 99.00,
    img: img6,
    type: "Sale",
    categories: "Potter Plants"
  },
  {
    id: 12,  
    name: "Broadleaf Lady Palm",
    price: 59.00,
    img: img7,
    type: "Sale",
    categories: "Potter Plants"
  },
  {
    id: 13,  
    name: "Chinese Evergreen",
    price: 39.00,
    img: img9,
    type: "Sale",
    categories: "Potter Plants"
  },
  {
    id: 14,
    name: "Barberton Daisy",
    price: 119.00,
    img: img1,
    categories: "Seeds"
  },
  {
    id: 15,
    name: "Cactus & Succulent",
    price: 169.00,
    img: img10,
    categories: "Seeds"
  },
  {
    id: 16,
    name: "African Violet",
    price: 199.00,
    img: img3,
    categories: "Seeds"
  },
  {
    id: 17,  
    name: "Chinese Evergreen",
    price: 39.00,
    img: img9,
    categories: "Small Plants"
  },
  {
    id: 18,
    name: "Barberton Daisy",
    price: 119.00,
    img: img13,
    categories: "Small Plants"
  },
  {
    id: 19,
    name: "Cactus & Succulent",
    price: 169.00,
    img: img1,
    categories: "Small Plants"
  },
  {
    id: 20,
    name: "African Violet",
    price: 199.00,
    img: img11,
    categories: "Big Plants"
  },
  {
    id: 21,
    name: "Barberton Daisy",
    price: 119.00,
    img: img14,
    categories: "Big Plants"
  },
  {
    id: 22,
    name: "Cactus & Succulent",
    price: 169.00,
    img: img15,
    categories: "Big Plants"
  },
  {
    id: 23,
    name: "African Violet",
    price: 199.00,
    img: img3,
    categories: "Big Plants"
  },{
    id: 24,
    name: "Barberton Daisy",
    price: 119.00,
    img: img1,
    categories: "Succulents "
  },
  {
    id: 25,
    name: "Angel Wing Begonia",
    price: 169.00,
    img: img2,
    categories: "Succulents "
  },
  {
    id: 26,  
    name: "Beach Spider Lily",
    price: 129.00,
    img: img4,
    categories: "Trerrariums "
  },
  {
    id: 27,
    name: "Blushing Bromeliad",
    price: 139.00,
    img: img5,
    categories: "Trerrariums "
  },
  {
    id: 28,  
    name: "Aluminum Plant",
    price: 179.00,
    img: img4,
    categories: "Trerrariums "
  },
  {
    id: 29,
    name: "Bird's Nest Fern",
    price: 99.00,
    img: img6,
    categories: "Gardening "
  },
  {
    id: 30,  
    name: "Broadleaf Lady Palm",
    price: 59.00,
    img: img7,
    categories: "Gardening"
  },
  {
    id: 31,  
    name: "Chinese Evergreen",
    price: 39.00,
    img: img9,
    categories: "Gardening"
  },
  {
    id: 32,
    name: "Cactus & Succulent",
    price: 169.00,
    img: img10,
    categories: "Accessories"
  },
  {
    id: 33,
    name: "African Violet",
    price: 199.00,
    img: img3,
    categories: "Accessories"
  },
  {
    id: 34,  
    name: "Chinese Evergreen",
    price: 39.00,
    img: img9,
    categories: "Accessories"
  },
  {
    id: 35,
    name: "Barberton Daisy",
    price: 119.00,
    img: img13,
    categories: "Accessories"
  },
]

export default data